import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'

const AppError3 = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_error_tri" />
				<h3 className="intro-tit mt_20">서비스 점검 중이에요.</h3>
				<span className="intro-sub-tit mt_10">자세한 사항은 공지사항을 통해<br />확인 부탁드려요.</span>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">재시도</Button>
			</div>
		</div>
	)
}

export default AppError3